"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numeral = require("numeral");
var configuration_1 = require("../../configuration");
var AdFormatAdapter = (function () {
    function AdFormatAdapter(input) {
        this.value = input.id;
        this.commonAdformat = input.isStandard ? "AW" : "IW";
        this.name = input.title;
        this.setStandardFor(_.get(input, "tariffCondition"));
        var infoObject = AdFormatAdapter.keyValueArrayToObject(input.info);
        if (infoObject) {
            var base = 10;
            this.ovkId = parseInt(infoObject["OVKID"], base) || undefined;
            if (_.get(infoObject, "In-Page") === "true") {
                this.inPage = "In-Page";
            }
            else if (_.get(infoObject, "In-Stream") === "true") {
                this.inPage = "In-Stream";
            }
            if (infoObject["einordnung"]) {
                this.classification = _.capitalize(infoObject["einordnung"]);
            }
            this.exp = AdFormatAdapter.isTruthy(infoObject["expandable"]);
            this.video = AdFormatAdapter.isTruthy(infoObject["video"]);
            this.sticky = AdFormatAdapter.isTruthy(infoObject["sticky"]);
            if (infoObject["WerbeformName"]) {
                this.name = infoObject["WerbeformName"];
            }
            if (infoObject["description"]) {
                this.description = infoObject["description"];
            }
            this.setStandardValues(infoObject);
        }
        this.setSpecificValues(input);
    }
    AdFormatAdapter.prototype.setStandardFor = function (tariffConditionId) {
        if (tariffConditionId) {
            this.standardFor = tariffConditionId;
        }
    };
    AdFormatAdapter.isTruthy = function (input) {
        if (!input) {
            return false;
        }
        var inputLower = input.toLocaleLowerCase();
        return inputLower === "true" || inputLower === "ja";
    };
    AdFormatAdapter.keyValueArrayToObject = function (input) {
        if (!input) {
            return undefined;
        }
        var result = {};
        input.forEach(function (item) {
            if (item) {
                result[item.key] = item.value;
            }
        });
        return result;
    };
    AdFormatAdapter.prototype.setStandardValues = function (infoObject) {
        var base = 10;
        var minWidth = parseInt(infoObject["minWidth"], base) || undefined;
        var minHeight = parseInt(infoObject["minHeight"], base) || undefined;
        var width = parseInt(infoObject["maxWidth"], base) || undefined;
        var height = parseInt(infoObject["maxHeight"], base) || undefined;
        this.minMeasurements = { width: minWidth, height: minHeight };
        this.measurements = { width: width, height: height };
        this.weight = parseInt(infoObject["weight"], base) || undefined;
    };
    AdFormatAdapter.prototype.setSpecificValues = function (input) {
        if (input.cpm) {
            var cpm = input.cpm;
            if (cpm.onRequest === true) {
                this.cpmFormatted = "Auf Anfrage";
            }
            else if (cpm.amount) {
                this.cpmFormatted = numeral(cpm.amount).format("0,000.00");
            }
        }
        if (!this.cpmFormatted) {
            this.cpmFormatted = configuration_1.PlanConfiguration.ERROR_STRING;
        }
        if (input.fixedPrices) {
            this.setFixedPrices(input.fixedPrices);
        }
        if (input.potential) {
            this.potential = input.potential;
            this.potentialFormatted = numeral(input.potential).format("0%");
        }
    };
    AdFormatAdapter.prototype.setFixedPrices = function (fixedPrices) {
        var _this = this;
        fixedPrices.forEach(function (fixedPrice) {
            switch (fixedPrice.period) {
                case "DM":
                    _this.priceMonth = AdFormatAdapter.getFixedPriceAmount(fixedPrice);
                    break;
                case "DW":
                    _this.priceWeek = AdFormatAdapter.getFixedPriceAmount(fixedPrice);
                    _this.priceMonth = AdFormatAdapter.getFixedPriceAmount(AdFormatAdapter.calcMonthFixedPrice(fixedPrice));
                    break;
                case "DD":
                    _this.priceDay = AdFormatAdapter.getFixedPriceAmount(fixedPrice);
                    break;
                case "DR":
                    _this.priceMoFr = AdFormatAdapter.getFixedPriceAmount(fixedPrice);
                    break;
                case "DS":
                    _this.priceSaSu = AdFormatAdapter.getFixedPriceAmount(fixedPrice);
                    break;
                default:
            }
        });
    };
    AdFormatAdapter.getFixedPriceAmount = function (fixedPrice) {
        if (fixedPrice.onRequest === true) {
            return "Auf Anfrage";
        }
        else {
            return fixedPrice.amount.toString();
        }
    };
    AdFormatAdapter.calcMonthFixedPrice = function (weekFixedPrice) {
        var monthFixedPrice = weekFixedPrice;
        var daysInWeek = 7;
        var daysInMonth = 30;
        monthFixedPrice.amount = monthFixedPrice.amount * daysInMonth / daysInWeek;
        return monthFixedPrice;
    };
    return AdFormatAdapter;
}());
exports.AdFormatAdapter = AdFormatAdapter;
//# sourceMappingURL=adformatAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/adformatAdapter.js
// module id = 39
// module chunks = 0